import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Open24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M10.5482 5.5H5.5V18.4955H18.4954V13.4473C18.4954 13.0331 18.8312 12.6973 19.2454 12.6973C19.6597 12.6973 19.9954 13.0331 19.9954 13.4473V18.7455C19.9954 19.4358 19.4358 19.9955 18.7454 19.9955H5.25C4.55964 19.9955 4 19.4358 4 18.7455V5.25C4 4.55964 4.55964 4 5.25 4H10.5482C10.9624 4 11.2982 4.33579 11.2982 4.75C11.2982 5.16421 10.9624 5.5 10.5482 5.5Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.1469 4.75C14.1469 4.33579 14.4826 4 14.8969 4H19.2455C19.3472 4 19.4441 4.02024 19.5326 4.05691C19.621 4.09351 19.7039 4.14776 19.7758 4.21967C19.8477 4.29158 19.902 4.37445 19.9386 4.46291C19.975 4.55069 19.9952 4.64688 19.9955 4.74775L19.9955 4.75V9.09864C19.9955 9.51285 19.6597 9.84864 19.2455 9.84864C18.8313 9.84864 18.4955 9.51285 18.4955 9.09864V6.56066L11.0785 13.9776C10.7857 14.2705 10.3108 14.2705 10.0179 13.9776C9.72499 13.6847 9.72499 13.2098 10.0179 12.917L17.4348 5.5H14.8969C14.4826 5.5 14.1469 5.16421 14.1469 4.75Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
